import React from 'react';
import { X, MessageSquare, Clock } from 'lucide-react';

const TranscriptModal = ({ isOpen, onClose, responses, employeeName }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/50 z-[100] flex items-center justify-center p-0 md:p-4">
            <div className="bg-white rounded-none md:rounded-2xl w-full h-full md:h-auto md:max-w-2xl md:max-h-[80vh] flex flex-col shadow-2xl animate-scaleIn">
                {/* Header */}
                <div className="p-4 md:p-6 border-b border-gray-100 flex justify-between items-center bg-gray-50 rounded-none md:rounded-t-2xl safe-area-top">
                    <div className="flex items-center gap-3">
                        <div className="bg-blue-100 p-2 rounded-lg text-blue-600">
                            <MessageSquare size={20} />
                        </div>
                        <div>
                            <h3 className="text-lg font-bold text-gray-800">{employeeName}'s Transcript</h3>
                            <p className="text-xs text-gray-500">Full conversation history</p>
                        </div>
                    </div>
                    <button onClick={onClose} className="p-2 hover:bg-gray-200 rounded-full transition-colors text-gray-500">
                        <X size={20} />
                    </button>
                </div>

                {/* Content */}
                <div className="flex-1 overflow-y-auto p-4 md:p-6 space-y-6">
                    {responses.length === 0 ? (
                        <div className="text-center text-gray-400 py-10">No responses recorded.</div>
                    ) : (
                        responses.map((resp, idx) => (
                            <div key={idx} className="flex flex-col gap-2">
                                {/* Question (AI) */}
                                <div className="flex justify-start">
                                    <div className="bg-gray-100 text-gray-800 px-4 py-3 rounded-2xl rounded-tl-none max-w-[85%] text-sm">
                                        <p className="font-semibold text-xs text-gray-500 mb-1 uppercase tracking-wider">AI Assistant</p>
                                        <p>{resp.snapshot_question_text || "Question Text Missing"}</p>
                                    </div>
                                </div>

                                {/* Answer (User) */}
                                <div className="flex justify-end">
                                    <div className={`px-4 py-3 rounded-2xl rounded-tr-none max-w-[85%] text-sm ${resp.skipped ? 'bg-yellow-50 text-yellow-700 border border-yellow-200' : 'bg-blue-600 text-white shadow-md'
                                        }`}>
                                        <p className={`font-semibold text-xs mb-1 uppercase tracking-wider ${resp.skipped ? 'text-yellow-600' : 'text-blue-200'}`}>
                                            {employeeName}
                                        </p>
                                        <p>{resp.skipped ? "(Skipped)" : resp.response_text}</p>
                                    </div>
                                </div>

                                <div className="flex justify-center">
                                    <span className="text-[10px] text-gray-300 flex items-center gap-1">
                                        <Clock size={10} /> {new Date(resp.created_at).toLocaleTimeString()}
                                    </span>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default TranscriptModal;
